<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="type" @change="getSettles">
            <el-option label="全部" :value="0" />
            <el-option label="待审批" :value="1" />
            <el-option label="审批通过" :value="2" />
            <el-option label="审批拒绝" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getSettles">查询</el-button>
        </el-form-item>
        <!-- <el-form-item v-if="isSuperAdmin">
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>-->
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="orders"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%;"
      fixed
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column type="index" width="70"></el-table-column>
      <el-table-column prop="creator" label="创建者"></el-table-column>
      <el-table-column width="180" prop="auditAmount" label="申请时间" :formatter="formatSettleTime"></el-table-column>

      <el-table-column prop="amount" label="申请提现金额"></el-table-column>
      <el-table-column prop="note" label="提现备注"></el-table-column>
      <el-table-column
        width="150"
        prop="hotel_id"
        label="酒店名"
        :formatter="
          row =>
            row.hotel_id
              ? row.from == 1
                ? hotelMap[row.hotel_id].tzName
                : hotelMap[row.hotel_id].dltName
              : '-'
        "
      ></el-table-column>
      <el-table-column prop="auditStatus" label="审核状态" :formatter="getSettleStatus"></el-table-column>
      <el-table-column prop="auditAmount" label="审核金额"></el-table-column>
      <el-table-column prop="auditDetail" label="审核备注"></el-table-column>

      <el-table-column label="操作" width="250">
        <template scope="scope">
          <el-button size="small" @click="handleExcel(scope.$index, scope.row)">订单excel</el-button>
          <el-button
            size="small"
            v-if="scope.row.auditStatus < 2"
            @click="handleEdit(scope.$index, scope.row)"
          >审核</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >-->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="审核" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="审批状态" prop="hotel_id">
          <el-select v-model="editForm.auditStatus" class="long-select">
            <el-option label="审批通过" :value="2" />
            <el-option label="审批拒绝" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="审批金额" prop="auditAmount">
          <el-input v-model="editForm.auditAmount" type="number" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="auditDetail">
          <el-input v-model="editForm.auditDetail" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="用户名" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="addForm.role">
            <el-option label="超级管理员" :value="0"></el-option>
            <el-option label="普通管理员" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../common/js/util";
import NProgress from "nprogress";
import { adminApi, hotelApi, orderApi, auditApi } from "../../api/api";
import { mapGetters } from "vuex";
import fecha from "fecha";
import XLSX from "xlsx";
import { tzOrderStatusMap, handleStatusMap, settleMap } from "../../constant";
export default {
  data() {
    return {
      type: 0,
      clerkRow: [],
      stausMap: {},
      hotelMap: {},
      hotels: [],
      filters: {
        name: ""
      },
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        //   role: [{ required: true, message: '请输入角色', trigger: 'blur' }],
      },
      //编辑界面数据
      editForm: {
        auditAmount: 0,
        auditStatus: 2,
        auditDetail: ""
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        name: "",
        password: "",
        role: 1
      }
    };
  },
  methods: {
    //性别显示转换
    formatRole: function(row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    formatSettleTime(row) {
      return row.settleTime
        ? fecha.format(new Date(row.settleTime), "YYYY-MM-DD HH:mm:SS")
        : "-";
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getSettles();
    },
    //获取用户列表
    getSettles() {
      let para = {
        page: this.page,
        type: this.type
      };
      this.listLoading = true;
      NProgress.start();
      orderApi.settleList(para).then(res => {
        this.total = res.data.count;
        res.data.rows.forEach(row => {
          const clerk = this.clerkRow.find(i => i.open_id === row.creator);
          clerk && (row.creator = clerk.name);
          typeof row.amount === "number" && (row.amount = row.amount / 100);
          typeof row.auditAmount === "number" &&
            (row.auditAmount = row.auditAmount / 100);
        });
        this.orders = res.data.rows;
        this.listLoading = false;
        NProgress.done();
      });
    },
    getHandleStatus(row) {
      return !!row.handleStatus
        ? handleStatusMap[row.handleStatus] || "未处理"
        : "未处理";
    },
    handleExcel(index, row) {
      orderApi
        .settlingOrder({ id: row.id })
        .then(res => {
          if (!res.code) {
            const rows = res.data;
            const firstLine = [
              "客户名",
              "房型",
              "入住日期",
              "离店日期",
              "晚",
              "间",
              "价格",
              "备注"
            ];
            const datas = rows.map(
              ({
                checkInDate,
                checkOutDate,
                goodsName,
                guestName,
                stay,
                roomCount,
                price,
                note
              }) => [
                guestName,
                goodsName,
                fecha.format(new Date(checkInDate), "YYYY-MM-DD"),
                fecha.format(new Date(checkOutDate), "YYYY-MM-DD"),
                stay,
                roomCount,
                price / 100,
                ""
              ]
            );
            var filename = `结算${row.id}.xlsx`; //文件名称
            var data = [firstLine, ...datas];
            var ws_name = "Sheet1";
            var wb = XLSX.utils.book_new(),
              ws = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, ws_name); //将数据添加到工作薄
            XLSX.writeFile(wb, filename); //导出Excel
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    getSettleStatus(row) {
      return settleMap[row.auditStatus];
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true;
      this.editForm.id = row.id;
    },
    //编辑
    editSubmit: function() {
      if (this.editForm.auditStatus == 2 && this.editForm.auditAmount == "0") {
        return this.$message.error("请确认审批金额");
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              orderApi.settle(para).then(res => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getSettles();
              });
            })
            .finally(_ => {
              this.editLoading = false;
            });
        }
      });
    },

    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      var ids = this.sels.map(item => item.id).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };
          batchRemoveUser(para).then(res => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getSettles();
          });
        })
        .catch(() => {});
    },
    getHotelMap() {
      hotelApi.listMap().then(({ data }) => {
        this.hotelMap = data;
        this.hotels = Object.entries(data);
      });
    },
    getClerkMap() {
      auditApi
        .list({
          all: 1
        })
        .then(({ data: { rows } }) => {
          this.clerkRow = rows;
        });
    }
  },
  created() {
    this.fecha = fecha;
    this.getHotelMap();
    this.getClerkMap();
  },
  mounted() {
    this.getSettles();
  },
  computed: {
    ...mapGetters(["getUserInfo", "isSuperAdmin"])
  }
};
</script>

<style scoped>
.long-select {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// settle.vue?624d72de